import React from 'react'
import { useMutation } from 'react-query'
import TernarySelector, {
  SelectableOption,
} from 'scenes/Dashboard/components/AssessmentsView/components/AssessmentTable/components/AssessmentRow/components/TernarySelector'
import { Deal } from 'scenes/Dashboard/data/deals/types'
import { makeStyles } from 'tss-react/mui'
import { QueryStatus } from 'utils-next/api'
import { ExtendableStyles } from 'utils-next/types'

import { FormControlLabel } from '@mui/material'

import { useDealHandlers } from './DealCard.container'

export type DealIsValidProps = ExtendableStyles & {
  deal: Deal
}

export function DealIsValid({ deal }: DealIsValidProps) {
  const { classes } = useStyles()
  const { updateDealIsValid: updateDealIsValid } = useDealRelaxedSweetSpotHandlers(deal)
  const { status, mutate: handleChange } = useMutation(updateDealIsValid)

  return (
    <FormControlLabel
      control={
        <TernarySelector
          selectedOption={mapToSelectableOption(deal.isValid)}
          onSelect={(selectedOption) => {
            const isValid = {
              [SelectableOption.Unknown]: null,
              [SelectableOption.Yes]: true,
              [SelectableOption.No]: false,
            }[selectedOption]

            handleChange(isValid)
          }}
        />
      }
      disabled={status === QueryStatus.loading}
      label="Is Valid"
      className={classes.isValidRow}
    />
  )
}

function useDealRelaxedSweetSpotHandlers(deal: Deal) {
  const { updateDealData } = useDealHandlers(deal.id)
  const updateDealIsValid = (isValid?: boolean | null) => updateDealData({ ...deal, isValid: isValid })
  return {
    updateDealIsValid: updateDealIsValid,
  }
}

function mapToSelectableOption(isValid?: boolean | null): SelectableOption {
  if (isValid === null) {
    return SelectableOption.Unknown
  } else {
    return isValid ? SelectableOption.Yes : SelectableOption.No
  }
}

const useStyles = makeStyles()(() => ({
  isValidRow: {
    marginLeft: '0 !important',
  },
}))
